import { createStyles, makeStyles } from '@material-ui/core';
import { colorVariables } from '../../../../../styles/colorVariables';
import { Sizes } from '../../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: 16,
      borderBottom: '1px solid #E4E8ED',
    },
    expiredText: {
      color: colorVariables.red80,
    },
    last4Text: {
      marginRight: 25,
    },
    paymentTitle: {
      textTransform: 'capitalize',
      fontSize: 14,
      fontWeight: 700,
      color: colorVariables.navy,
    },
    paymentSubTitle: {
      fontSize: 14,
      fontWeight: 400,
      color: colorVariables.grey80,
    },
    actionsContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'end',
    },
    defaultChip: {
      fontSize: 11,
      fontWeight: 700,
      backgroundColor: '#fff',
      border: `1px solid ${colorVariables.steelGrey}`,
    },
    rightIcon: {
      alignContent: 'center',
      cursor: 'pointer',
      marginLeft: 100,
      [theme.breakpoints.down(Sizes.mobile)]: {
        marginLeft: 0,
      },
    },
    setDefaultText: {
      fontSize: 14,
      fontWeight: 600,
      color: colorVariables.blue,
      cursor: 'pointer',
    }
  }),
);
